import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DataTable from './DataTable';
import ClientProvider from './client';
export default createDemo(import.meta.url, DataTable, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/table/demos/data/DataTable.tsx",
    "fileName": "DataTable.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import {\n  DataGrid,\n  GridCell,\n  type GridCellProps,\n  type GridColDef,\n} from '@mui/x-data-grid';\nimport Paper from '@mui/material/Paper';\n\nconst columns: GridColDef[] = [\n  { field: 'id', headerName: 'ID', width: 70 },\n  { field: 'firstName', headerName: 'First name', width: 130 },\n  { field: 'lastName', headerName: 'Last name', width: 130 },\n  {\n    field: 'age',\n    headerName: 'Age',\n    type: 'number',\n    width: 90,\n  },\n  {\n    field: 'fullName',\n    headerName: 'Full name',\n    description: 'This column has a value getter and is not sortable.',\n    sortable: false,\n    width: 160,\n    valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,\n  },\n];\n\nconst rows = [\n  { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },\n  { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },\n  { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },\n  { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },\n  { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },\n  { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },\n  { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },\n  { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },\n  { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },\n];\n\nconst paginationModel = { page: 0, pageSize: 5 };\n\nfunction renderRowHeaderCell(props: GridCellProps) {\n  return (\n    <GridCell\n      {...props}\n      role={props.column.field === 'fullName' ? 'rowheader' : 'gridcell'}\n    />\n  );\n}\n\nexport default function DataTable() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Paper sx={{ height: 400, width: '100%' }}>\n      <DataGrid\n        rows={rows}\n        columns={columns}\n        initialState={{ pagination: { paginationModel } }}\n        pageSizeOptions={[5, 10]}\n        checkboxSelection\n        slots={{ cell: renderRowHeaderCell }}\n        sx={{ border: 0 }}\n      />\n    </Paper>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 66,
        "focusedLines": 11,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import {\n  DataGrid,\n  GridCell,\n  type GridCellProps,\n  type GridColDef,\n} from '@mui/x-data-grid';\nimport Paper from '@mui/material/Paper';\n\nconst columns: GridColDef[] = [\n  { field: 'id', headerName: 'ID', width: 70 },\n  { field: 'firstName', headerName: 'First name', width: 130 },\n  { field: 'lastName', headerName: 'Last name', width: 130 },\n  {\n    field: 'age',\n    headerName: 'Age',\n    type: 'number',\n    width: 90,\n  },\n  {\n    field: 'fullName',\n    headerName: 'Full name',\n    description: 'This column has a value getter and is not sortable.',\n    sortable: false,\n    width: 160,\n    valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,\n  },\n];\n\nconst rows = [\n  { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },\n  { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },\n  { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },\n  { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },\n  { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },\n  { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },\n  { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },\n  { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },\n  { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },\n];\n\nconst paginationModel = { page: 0, pageSize: 5 };\n\nfunction renderRowHeaderCell(props: GridCellProps) {\n  return (\n    <GridCell\n      {...props}\n      role={props.column.field === 'fullName' ? 'rowheader' : 'gridcell'}\n    />\n  );\n}\n\nexport default function DataTable() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <Paper sx={{ height: 400, width: '100%' }}>\n      <DataGrid\n        rows={rows}\n        columns={columns}\n        initialState={{ pagination: { paginationModel } }}\n        pageSizeOptions={[5, 10]}\n        checkboxSelection\n        slots={{ cell: renderRowHeaderCell }}\n        sx={{ border: 0 }}\n      />\n    </Paper>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 54
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "Paper"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "height"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "400"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "width"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "100%",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 55
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "DataGrid"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 56
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "rows"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "rows"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 57
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "columns"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "columns"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 58
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "initialState"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "pagination"
              ],
              ": { ",
              [
                "span",
                "pl-smi di-jv",
                "paginationModel"
              ],
              " } }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 59
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "pageSizeOptions"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "[",
              [
                "span",
                "pl-c1 di-num",
                "5"
              ],
              ", ",
              [
                "span",
                "pl-c1 di-num",
                "10"
              ],
              "]",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 60
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "checkboxSelection"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 61
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "slots"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "cell"
              ],
              ": ",
              [
                "span",
                "pl-smi di-jv",
                "renderRowHeaderCell"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 62
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "border"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "0"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 63
            },
            "      />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 64
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "Paper"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 66,
    "focusedLines": 11,
    "collapsible": true,
    "externals": [
      "@mui/x-data-grid",
      "@mui/material/Paper"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
